import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
	isLoadingSignal = signal(true);

	start() {
		this.isLoadingSignal.set(true);
	}

	stop() {
		this.isLoadingSignal.set(false);
	}
}
